/**
 * ランキングのチェックボックスを同期的に切り替える
 *
 * 同じ value 属性を持つ全てのチェックボックスの状態を同期的に切り替えます。
 * @param {string} inputName チェックボックスの name 属性
 */
function toggleRankingCheckbox(inputName) {
	const checkboxes = document.querySelectorAll(`input[name="${inputName}"]`);
	checkboxes.forEach(checkbox => {
		checkbox.addEventListener('change', () => {
			// チェックボックスの value とチェック状態を取得
			const value = checkbox.value;
			const isChecked = checkbox.checked;

			// 同じ value を持つ全てのチェックボックスの状態を同期
			document.querySelectorAll(`input[value="${value}"]`).forEach(target => {
				target.checked = isChecked;
			});
		});
	});
}

/**
 * フィルターボタンエリアの表示切替
 *
 * チェックボックスの状態に応じてフィルターボタンエリアを表示または非表示にします。
 * @param {string} inputName チェックボックスの name 属性
 * @param {string} className フィルターボタンエリアのクラス名
 */
function toggleRankingFilterButtonArea(inputName, className) {
	const checkboxes = document.querySelectorAll(`input[name="${inputName}"]`);
	const filterAreas = Array.from(document.getElementsByClassName(className));

	// チェックボックスまたはフィルターボタンエリアが存在しない場合は終了
	if (!checkboxes.length || !filterAreas.length) return;

	// 初期状態でフィルターボタンエリアを画面外に移動
	filterAreas.forEach(area => {
		area.style.translate = `0 ${area.offsetHeight + 8}px`;
	});

	/**
	 * フィルターボタンエリアの更新処理
	 * チェックボックスの状態に応じてエリアを表示/非表示にします。
	 */
	const updateFilterArea = () => {
		let hasChecked = false;

		checkboxes.forEach(checkbox => {
			// チェックボックスの状態に応じてフィルタ項目の表示を切り替え
			const filterItem = document.querySelector(`[data-filter-id="${checkbox.value}"]`);
			if (checkbox.checked) {
				filterItem.style.display = 'flex';
				hasChecked = true;
			} else {
				filterItem.style.display = 'none';
			}
		});

		// フィルターボタンエリアの位置を切り替え
		filterAreas.forEach(area => {
			area.style.translate = hasChecked ? '0 0' : `0 ${area.offsetHeight + 8}px`;
		});
	};

	// 各チェックボックスに変更イベントを設定
	checkboxes.forEach(checkbox => {
		checkbox.addEventListener('change', updateFilterArea);
	});
}

/**
 * ランキングテーブルの表示切替
 *
 * フィルターボタンやチェックボックスの状態に基づき、ランキングテーブルを表示または非表示にします。
 * @param {string} inputName チェックボックスの name 属性
 * @param {string} className フィルターボタンエリアのクラス名
 * @param {string} tableName テーブルのクラス名
 * @param {string} closeButtonName 閉じるボタンのクラス名
 */
function toggleRankingTable(inputName, className, tableName) {
	const checkboxes = document.querySelectorAll(`input[name="${inputName}"]`);
	const filterAreas = Array.from(document.getElementsByClassName(className));
	const tables = Array.from(document.getElementsByClassName(tableName));

	// チェックボックスやフィルターボタンエリアが存在しない場合は終了
	if (!checkboxes.length || !filterAreas.length) return;

	// サブミットボタンとリセットボタンを取得
	const submitButtons = filterAreas.flatMap(area =>
		Array.from(area.querySelectorAll('[data-filter-button="submit"]'))
	);
	const resetButtons = filterAreas.flatMap(area =>
		Array.from(area.querySelectorAll('[data-filter-button="reset"]'))
	);

	// サブミットボタンクリック時の処理
	submitButtons.forEach(button => {
		button.addEventListener('click', () => {
			// 各チェックボックスの状態に応じてテーブルセルを表示/非表示
			tables.forEach(table => {
				checkboxes.forEach(checkbox => {
					const cells = table.querySelectorAll(`[data-id="${checkbox.value}"]`);
					cells.forEach(cell => {
						cell.style.display = checkbox.checked ? 'table-cell' : 'none';
					});
				});
			});
		});
	});

	// リセットボタンクリック時の処理
	resetButtons.forEach(button => {
		button.addEventListener('click', () => {
			// チェックボックスをすべてオフに
			checkboxes.forEach(checkbox => (checkbox.checked = false));

			// フィルターボタンエリアを非表示
			filterAreas.forEach(area => {
				area.style.bottom = `-${area.offsetHeight + 8}px`;
			});
		});
	});
}

/**
 * ランキングフィルターをまとめて設定
 *
 * @param {string} inputName チェックボックスの name 属性
 * @param {string} className フィルターボタンエリアのクラス名
 * @param {string} tableName テーブルのクラス名
 * @param {string} closeButtonName 閉じるボタンのクラス名
 */
export function rankingFilters(inputName, className, tableName) {
	toggleRankingCheckbox(inputName);
	toggleRankingFilterButtonArea(inputName, className);
	toggleRankingTable(inputName, className, tableName);
}
